import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, RefreshCw, Sparkles, KeyRound } from "lucide-react";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get("/admin/users");
      setUsers(r.data);
    } catch {
      toast.error("Failed to load registered users");
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  return (
    <div data-testid="admin-users-page" className="min-h-screen max-w-7xl mx-auto px-6 lg:px-10 py-12">
      <Link to="/admin" className="inline-flex items-center gap-2 text-xs text-white/60 hover:text-white mb-6"><ArrowLeft size={14} /> Back to Products</Link>
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="overline">Customers</div>
          <h1 className="section-title text-3xl sm:text-4xl">Registered Users</h1>
        </div>
        <button onClick={load} className="btn-ghost" data-testid="admin-users-refresh"><RefreshCw size={14} /> Refresh</button>
      </div>

      {loading && <div className="text-white/50 text-sm">Loading…</div>}
      {!loading && users.length === 0 && (
        <div className="text-center py-20 text-white/50 font-body" data-testid="admin-users-empty">No registered customers yet.</div>
      )}

      <div className="space-y-3">
        {users.map((u) => (
          <div key={u.id} data-testid={`admin-user-${u.id}`} className="flex flex-col sm:flex-row sm:items-center gap-3 border border-white/10 p-4 hover:border-[#D96A1B]/40 transition-colors">
            <div className="flex-1">
              <div className="font-display uppercase tracking-tight text-sm text-white">{u.name}</div>
              <div className="text-xs text-white/50 mt-1">{u.email}{u.phone ? ` · ${u.phone}` : ""}</div>
            </div>
            <div className="flex items-center gap-2 flex-wrap">
              {u.auto_created && (
                <span className="inline-flex items-center gap-1 text-[10px] text-[#D96A1B] font-display tracking-widest uppercase border border-[#D96A1B]/40 px-2 py-1">
                  <Sparkles size={11} /> Auto-Created
                </span>
              )}
              {u.must_change_password && (
                <span className="inline-flex items-center gap-1 text-[10px] text-yellow-400 font-display tracking-widest uppercase border border-yellow-400/40 px-2 py-1">
                  <KeyRound size={11} /> Password Pending
                </span>
              )}
              <span className="text-[10px] text-white/40 font-display tracking-widest uppercase">{new Date(u.created_at).toLocaleDateString()}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
